<template>
  <div
    id="reportTable"
    class="report-table" :class="showColumnExp? 'reportPadding' : '' "
    :style="{height: height}">
    <a :id="downloadAName" href="#" download="download" style="position: fixed;visibility: hidden;"></a>
    <el-table
      :class="isFirefox? 'isFirefox' : '' "
      ref="table"
      :data="realTableData"
      border
      stripe
      height="100%"
      style="width:100%;overflow:auto;height:100%;"
      v-watermark:name="imagePath"
      :cell-style=bodyStyle
      :cell-class-name="cellStyle"
      :header-cell-style=headerStyle
      @sort-change="handlerSort"
      @cell-click="handlerCellClick"
      highlight-current-row
      :row-key="getRowKeys"
      @selection-change = "handleCurrentChange"
      @row-click="selectRow"
      @select="handlerSelect"
      @select-all="handlerSelectAll"
      @current-change="handlerCurrent"
      @expand-change="showSubTable"
    >

      <!--<el-table-column-->
        <!--v-for="(column,index) in tableColumns"-->
        <!--v-if="!column.hidden"-->
        <!--:key="index"-->
        <!--:prop="column.name"-->
        <!--:label="column.title"-->
        <!--align="right"-->
      <!--&gt;-->
      <!--</el-table-column>-->
      <report-column
      v-for="(column, $index) in realTableColumns"
      v-if="!column.hidden"
      :key="$index"
      :index="$index"
      :pageSize="pageSize"
      v-bind="column"
      :columnsLen="realTableColumns.length"
      :searchData="searchData"
      @refresh="refresh"
      @radioChecked="radioChecked"
      @radio.native="radioChecked"
      :radioCheckedValue="radioCheckedValue"
      :radioIndex="radioIndex"
      :subTable="subTable"
      @addDataBack="addDataBack"
      @showReport="showColumnButtonReport"
      @changeSubColumn="changeSubColumn"
      ></report-column>
    </el-table>
    <el-popover
      placement="top-start"
      title=""
      width="300"
      trigger="hover"
      >
      <div
        v-html="columnExp"
      >
      </div>
      <!--<div-->
        <!--slot="reference"-->
        <!--v-if="showColumnExp"-->
        <!--class="table-column-Exp"-->
        <!--@hover="showColumnExpDia"-->
      <!--&gt;-->
      <!--<i slot="reference"
         v-if="showColumnExp&&isTrue"
         style="color:#00a0e9;fontSize:20px; position: absolute; left:10px; top: -15px;z-index: 99;"
         class="iconfont icon-knodetailinfor">
      </i>
      <i slot="reference"
         v-if="showColumnExp&&!isTrue"
         style="color: #00a0e9; fontSize: 20px; position: absolute; left:10px; top:1px;z-index: 99;"
         class="iconfont icon-knodetailinfor">
      </i>
      </div>-->
      <span class="tabel-tip" slot="reference"
         v-if="showColumnExp" >
        <i
         class="iconfont icon-knodetailinfor ">

      </i>
        <span>指标说明</span>
      </span>
    </el-popover>
    <div
      v-if="showSetting"
      class="table-column-setting"
      @click="showTransfer"
    >
      <i class="icon-knodetailinfor setting-icon"></i>
    </div>
    <column-setting v-if="showSetting" :showColumnExp="showColumnExp" :table-columns="tableColumns" :code="reportCode" :showColumnSetting="showColumnSetting"></column-setting>
    <el-dialog
      title=""
      :visible.sync="showDialog"
      modal-append-to-body
      width="50%"
      :class=" isBaseForm?'dialog-base-form':''"
      center>

      <base-form
        v-bind="meta"
        :code="meta.code || meta.id"
        v-if="isBaseForm"
        :isDialog="inDialog"
        ref="customDialogBaseForm"
      ></base-form>
      <report v-else
        v-bind="meta"
        :isDialog="inDialog"
        code="name"
        ref="customdialogReport"
        @radioChecked="radioCheckedMethod"
        @checkbox="getCheckedReport"
      ></report>
      <div class="button-operator-area" v-if="isBaseForm" slot="footer">
        <el-button @click.native="reset">取 消</el-button>
        <el-button type="primary" @click.native="sureInTable()">确 定</el-button>
      </div>

      <div class="button-operator-area" v-else>
        <el-button @click.native="reset">取 消</el-button>
        <el-button type="primary" @click.native="sureInTable()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="" 
      :visible.sync="showTran"
      width="550px"
      :append-to-body="appendToBody"
      class="el-dialog_report-column-tran"
      @close="reset"
      center>
      <el-transfer
        v-model="tranValue"
        :data="tranData"
        :titles="titles"
      ></el-transfer>
      <div class="report-column-tran-buttons">
        <el-button @click="resetTran">取 消</el-button>
        <el-button type="primary" @click="sureTran">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import reportColumn from './reportColumn.vue'
  import columnSetting from './base/columnSetting.vue'

  import { getReportData } from '@/api/report.js'
  import columnsMixin from '../../../mixins/columnsMixin'
  import watermark from '@/directive/watermark/index.js'
  import { mapGetters } from 'vuex'
  let config = null
  try {
    config = require('@/_app/' + process.env.PROJECT + '/src/config/index').default
    console.log(config)
  } catch (e) {
    console.warn('config')
  }
  // import _ from 'lodash'
/* eslint-disable */
  export default {
    name: 'report-table',
    mixins: [columnsMixin],
    directives: {
      watermark
    },
    props: {
      searchData: {
        type: Object,
        default() {
          return {}
        }
      },
      tableColumns: {
        type: Array
      },
      tableData: {
        type: Array
      },
      paramsHeight: {
        type: Number
      },
      reportCode: {
        type: String
      },
      loading: {
        type: Boolean
      },
      currentPage: {
        type: String | Number
      },
      pageSize: {
        type: String | Number
      },
      indexH: {
        type: String
      },
      radioCheckedValue: {
        type: Object
      },
      radioIndex: {
        type: Number
      },
      subTable: {
        type: Object
      },
      showSetting: {
        type: Boolean,
        default: false
      },
      columnExp: {
        type: String
      }
    },
    components: {
      reportColumn,
      columnSetting
    },
    data() {
      this.scrollTop = 0
      this.scrollLeft = 0
      this.rowKey = 'key'
      this.bodyStyle = {
        'font-size': '12px',
        'padding': '0'
      }
      this.appendToBody = true
      this.titles = ['展示', '隐藏']
      return {
        isFirefox:false,
        height: '',
        headerStyle: {
          'font-size': '12px',
          'background-color': '#fff',
          'color': 'rgba(49, 65, 86, 0.82)',
          'padding': '0'
        },
        realTableColumns: this.tableColumns,
        realTableData: this.tableData,
        showTran: false,
        tranData: [],
        tranValue: [],
        showExp: false,
        isTrue: false,
        checkedColumns: [],
        isIndeterminate: true,
        checkAll: false,
      }
    },
    watch: {
      tableData: {
        handler(val) {
          this.realTableData = val
        },
        immediate: true,
        deep: true
      },
      tableColumns: {
        handler(val) {
          this.realTableColumns = this.tableColumns
        },
        immediate: true,
        deep: true
      },
    },
    computed: {
      downloadAName() {
        return this.code + '-download-a-name'
      },
      isBaseForm(){
        return this.meta.type === 'base-form'
      },
      mainHeight() {
        return this.$store.state.app.height
      },
      showColumnExp() {
        return !!this.columnExp
      },
      showColumnSetting(){
        return config && config.showColumnSetting
      },
      ...mapGetters([
        'imagePath'
      ])
    },
    created() {
      this.$eventBus.$on('showColumnExpFlag', (isTrue) => {
        this.isTrue = isTrue
      })
      this.$eventBus.$on('hide-dialog',()=>{
        this.reset()
      })
      this.$eventBus.$on('refresh-table-from-dialog',()=>{
        this.$emit('refresh')
      })
      var userAgent = navigator.userAgent
      var isFirefox = userAgent.indexOf('Firefox') > -1
      var isCamino = userAgent.indexOf('Chrome') > -1
      if(isFirefox||isCamino){
        this.isFirefox=true;
      }
    },
    mounted() {
      this.$nextTick(() => {
        if (this.paramsHeight) {
          if (!this.indexH) {
            // this.height = (this.mainHeight - 125 - this.paramsHeight) + 'px'
          } else {
            this.height = (this.indexH) + 'px'
          }
        } else {
          this.height = '310px'
        }
      })
      const that = this
      this.$el.querySelector('.el-table__body-wrapper').onscroll = function(event) {
        const top = that.$el.querySelector('.el-table__body-wrapper').scrollTop
        const left = that.$el.querySelector('.el-table__body-wrapper').scrollLeft

        that.scrollTop = top
        that.scrollLeft = left
      }
    },
    deactivated() {
    },
    activated() {
      this.$el.querySelector('.el-table__body-wrapper').scrollLeft = this.scrollLeft
      this.$el.querySelector('.el-table__body-wrapper').scrollTop = this.scrollTop
    },
    methods: {
      changeSubColumn(index,data){
        let subColumns = this.realTableColumns[index].subColumns
        // 清空之前的
        subColumns.length = 0
        for( let i = 0;i< data.length;i++ ){
           subColumns.push( Object.assign({"name": "20225",
             "align":"center",
             "title": "title",
             "showOverflowTooltip": true,
           },data[i]))
        }
      },
      // 处理表格显示图片过大的问题  先针对于原译处理
      cellStyle({row, column, rowIndex, columnIndex}) {
        if (process.env.PROJECT === 'outlet') {
          if (column.type === 'image') {
            return 'cellStyle'
          }
        }
      },
      showColumnExpDia() {
        this.showExp = true
      },
      sureTran() {
        this.realTableColumns.forEach((item, index) => {
          if (~this.tranValue.indexOf(index)) {
            item.hidden = true
          } else {
            item.hidden = false
          }
        })
        // const dataArray = []
        // this.realTableData.forEach((item) => {
        //  const obj = {}
        //  filterArr.forEach((column) => {
        //    const name = column.name
        //    obj[name] = item[name]
        //  })
        //  dataArray.push(obj)
        // })
        // this.realTableColumns = filterArr

        this.$nextTick(() => {
          this.showTran = false
        })
      },
      showTransfer() {
        this.showTran = true
      },
      resetTran() {
        this.showTran = false
      },
      addDataBack(obj) {
        const index = obj.index
        const type = obj.type
        const data = obj.data
        const open = obj.open
        if (type === 'table') {
          this.realTableData = this.realTableData.concat(data)
        } else if (type === 'row') {
          if (open) {
            const tempTableData = _.cloneDeep(this.realTableData)
            const length = tempTableData.length
            const tempData = tempTableData.splice(index + 1, length - (index + 1))
            const nData = tempTableData.concat(data, tempData)
            nData[index]['subData_opened'] = true
            this.realTableData = nData
          } else {
            const tiempTableData = _.cloneDeep(this.realTableData)
            const tiemplength = data.length
            tiempTableData.splice(index + 1, tiemplength)
            tiempTableData[index]['subData_opened'] = false
            this.realTableData = tiempTableData
          }
        }
      },
      showSubTable(row, expandedRows) {
        if (!row.children) {
          this.getData(row)
        }
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      },
      getData(row) {
        const path = this.subTable.path
        const that = this
        getReportData(path, row).then(res => {
          if (res.code === 0) {
            const data = res.data
            // const findRow = _.find(this.realTableData, row)
            that.$set(row, 'children', that.setDataKey(data.data, row))
          } else {
            this.$message({
              type: 'error',
              message: res.message,
              showClose: true
            })
          }
        }).catch(errData => {
          this.loadingData = false
        })
      },
      setDataKey(data, row) {
        data.forEach((item, index) => {
          item.key = 'children' + row.key + index
        })
        return data
      },
      setCheckeds(rows) {
        if (rows && rows.length > 0) {
          rows.forEach(row => {
            this.$refs.table.toggleRowSelection(row, true)
          })
        }
      },
      refresh(index, requeryType) {
        this.tableData.splice(index, 1)
        this.$emit('refresh', requeryType)
      },
      handlerSort(col) { // 排序
        this.$emit('sort', {
          'order': this.getSort(col.order),
          'prop': col.prop
        })
      },
      getSort(order) {
        if (!order) {
          return ''
        }
        if (order.indexOf('desc') > -1) {
          return 'desc'
        }
        if (order.indexOf('asc') > -1) {
          return 'asc'
        }
        return ''
      },
      radioChecked(row) {
        this.$emit('radioChecked', row)
      },
      handlerCellClick(row, column, cell, event) {},
      handleCurrentChange(val) {
        this.$emit('checkBoxChange', val)
        this.$eventBus.$emit('checkoutbox', val)
      },
      selectRow(row, event, column) {
        // this.$emit('radioChecked', row)
      },
      handlerSelect(selection, row) {},
      handlerSelectAll(selection) {},
      handlerCurrent(currentRow, oldCurrentRow) {},
      getRowKeys(row) {
        return row.key
      },
      clearSelection() {
        this.$refs.table.clearSelection()
      },
      showColumnButtonReport(obj) {
        this.showReport(obj.event, obj.row, obj.index)
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  $height: 32px;
  .button-operator-area{
    float: right;
    display: inline-block;
    margin-bottom:18px;
    padding-right:30px;
    .el-button {
      display: block;
      float: right;
      &:first-child{
        margin-left: 10px;
      }
    }
  }
  .el-dialog_report-column-tran{
    .report-column-tran-buttons{
      margin-left: 160px;
      margin-top: 24px;
    }
  }
  .report-table{
    flex:1;
    display: flex;
    padding-left: 20px;
    padding-right: 20px;
    position: relative;
    padding-top:20px;
    .el-table{
      height: none !important;
      height: auto !important;
    }
    .table-column-Exp{
      position: absolute;
      height: 14px;
      width: 20px;
      background: #42b983;
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
      left: 31px;
      top: -15px;
      z-index: 2;
      transition: .3s ease-in-out;
      cursor: pointer;
      &:hover{
         top: -30px;
         height:30px;
        .Exp-icon{
          display: block;
        }
      }
      .Exp-icon{
        font-size: 20px;
        color: #FAFAFA;
      }
    }
    .table-column-setting{
      position: absolute;
      height: 14px;
      width: 20px;
      background: #42b983;
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
      right: 31px;
      top: -15px;
      z-index: 2;
      transition: .3s ease-in-out;
      cursor: pointer;
      &:hover{
         top: -30px;
         height:30px;
         .setting-icon{
           display: block;
         }
       }
      .setting-icon{
        font-size: 20px;
        color: #FAFAFA;
      }
    }

  }
  .tabel-tip{
    color: #00a0e9; font-size: 20px; position: absolute; left:10px; top:1px;z-index: 99;
    span{
      font-size: 14px;
      color: #111111;
    }
  }
  .el-table__body-wrapper {
    position: absolute !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/report/components/reportTable.vue